export function scrollAnimations() {
    (function() {
        //Vertical animation for elements with .vertical-animate
        (function() {
            const $vertical = $('.vertical-animate');
            const verticalObserver = new IntersectionObserver((verticalItems) => {
                verticalItems.forEach((verticalItem) => {
                    if (verticalItem.isIntersecting) {
                        verticalItem.target.classList.add('animate-fadeInUp');
                        verticalObserver.unobserve(verticalItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $vertical.each(function() {
                verticalObserver.observe(this);
            });
        })();

        //Fade-In animation for elements with .fade-animate
        (function() {
            const $fade = $('.fade-animate');
            const fadeObserver = new IntersectionObserver((fadeItems) => {
                fadeItems.forEach((fadeItem) => {
                    if (fadeItem.isIntersecting) {
                        fadeItem.target.classList.add('animate-fade');
                        fadeObserver.unobserve(fadeItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $fade.each(function() {
                fadeObserver.observe(this);
            });
        })();

        //Fade-In from Right animation for elements with .fade-animate-right
        (function() {
            const $fadeRight = $('.fade-animate-right');
            const fadeRightObserver = new IntersectionObserver((fadeRightItems) => {
                fadeRightItems.forEach((fadeRightItem) => {
                    if (fadeRightItem.isIntersecting) {
                        fadeRightItem.target.classList.add('animate-fadeInRight');
                        fadeRightObserver.unobserve(fadeRightItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $fadeRight.each(function() {
                fadeRightObserver.observe(this);
            });
        })();

        //Fade-In from Left animation for elements with .fade-animate-left
        (function() {
            const $fadeLeft = $('.fade-animate-left');
            const fadeLeftObserver = new IntersectionObserver((fadeLeftItems) => {
                fadeLeftItems.forEach((fadeLeftItem) => {
                    if (fadeLeftItem.isIntersecting) {
                        fadeLeftItem.target.classList.add('animate-fadeInLeft');
                        fadeLeftObserver.unobserve(fadeLeftItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $fadeLeft.each(function() {
                fadeLeftObserver.observe(this);
            });
        })();

        //Fade-In from Bottom animation for elements with .fade-animate-up
        (function() {
            const $fadeUp = $('.fade-animate-up');
            const fadeUpObserver = new IntersectionObserver((fadeUpItems) => {
                fadeUpItems.forEach((fadeUpItem) => {
                    if (fadeUpItem.isIntersecting) {
                        fadeUpItem.target.classList.add('animate-fadeInUp');
                        fadeUpObserver.unobserve(fadeUpItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $fadeUp.each(function() {
                fadeUpObserver.observe(this);
            });
        })();

        //Fade-In from Top animation for elements with .fade-animate-down
        (function() {
            const $fadeDown = $('.fade-animate-down');
            const fadeDownObserver = new IntersectionObserver((fadeDownItems) => {
                fadeDownItems.forEach((fadeDownItem) => {
                    if (fadeDownItem.isIntersecting) {
                        fadeDownItem.target.classList.add('animate-fadeInDown');
                        fadeDownObserver.unobserve(fadeDownItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $fadeDown.each(function() {
                fadeDownObserver.observe(this);
            });
        })();

        //Fade-In Stagger animation for elements with .fade-animate-stagger
        (function() {
            const $stagger = $('.fade-animate-stagger');
            const staggerObserver = new IntersectionObserver((staggerItems) => {
                staggerItems.forEach((staggerItem) => {
                    if (staggerItem.isIntersecting) {
                        staggerItem.target.classList.add('animate-stagger');
                        staggerObserver.unobserve(staggerItem.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            $stagger.each(function() {
                staggerObserver.observe(this);
            });
        })();

        // Smooth scrolling for anchor links
        $('a[href*="#"]:not([href="#"]):not([role="tab"])').on('click', function(e) {
            const target = $(this.hash);
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 80
                }, 800, 'easeInOutCubic').promise().done(function() {
                    // Let listeners (e.g. anchor-links.js focus management)
                    // know the scroll has finished. .promise() resolves once
                    // for both html and body, so this fires a single time.
                    target.trigger('smoothscroll:end');
                });
            }
        });
    })();
}